var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.crossRegion
    ? _c(
        "feature-flag",
        { attrs: { name: "crossRegion.activeStatusTag" } },
        [
          _vm.isReady && _vm.cluster
            ? _c(
                _vm.tag,
                {
                  tag: "component",
                  staticClass: "active-status",
                  class:
                    ((_obj = {}), (_obj[_vm.classname] = _vm.classname), _obj),
                  attrs: {
                    name: "activeStatus",
                    options: _vm.selectList,
                    value: _vm.cluster
                  },
                  on: { change: _vm.onClusterChange }
                },
                [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0001a430", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0001a430","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/active-status/component.vue
// module id = 1381
// module chunks = 0